import type { FaireProductEntity } from "../../entity_types/product";

export const p_bj82mwwfsr: FaireProductEntity = {
  token: "p_bj82mwwfsr",
  type: "product",
  name: "Rocky Road Fudge",
  brandToken: "b_hxncymjum6",
  brandName: "Phenomenal Fudge",
  imageUrl:
    "https://cdn.faire.com/fastly/bfe222e4494d1469a71aace4fa96f18b827fdddefedbc1e3df775ee4cfdb2346.jpeg",
  galleryImageUrls: [],
  priceDollars: 7.58,
  description:
    "Rocky Road Fudge is the combination of crunchy home-roasted California walnuts and marshmallows all mixed into our regular chocolate fudge. It’s a fun flavor to enjoy with a variety of taste. FREE SHIPPING on all orders over $55. \n\nRocky Road Fudge in a 1/2 lb resealable tub.\n",
  tags: [],
  msrpDollars: 15.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:24.988Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
